import React from 'react';
import { LeftOutlined } from '@ant-design/icons';

interface TopNavBarProps {
  title: string;
  // onBack?: () => void;
  right?: React.ReactNode;
}

const TopNavBar: React.FC<TopNavBarProps> = ({ title, right }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        height: 52,
        background: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        padding: '0 16px',
        borderBottom: '1px solid #f0f0f0',
        minHeight: 52,
        transition: 'transform 0.25s cubic-bezier(.4,0,.2,1)',
        transform: 'translateY(0)',
        willChange: 'transform'
      }}
    >
      <div style={{ minWidth: 0, display: 'flex', alignItems: 'center' }} />
      <div style={{ flex: 1, textAlign: 'left', fontWeight: 700, fontSize: 18, color: '#1890ff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: 6 }}>
        {title}
      </div>
      <div style={{ minWidth: 40, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        {right}
      </div>
    </div>
  );
};

export default TopNavBar;
